module.exports = __webpack_public_path__ + "static/media/infoJumbo2.d3ce1dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Almi/images/infoJumbo2.jpg
// module id = 498
// module chunks = 0